module.exports = __webpack_public_path__ + "cd9adfc4.svg";